import React, { useState, useEffect } from "react";
import Toggle from "react-toggle";
import "react-toggle/style.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import AttendeeProfileList from './attendee_profile_list.js';

const ExistingAttendeeForm = ({ 
  existing_profiles = [],
  onExistingCamperSelect,
  campId,
  saveValues,
  nextStep,
  buttonStyles
}) => {
  const [state, setState] = useState({});
  const [error, setError] = useState("");

  // Announce form errors to screen readers
  useEffect(() => {
    if (error) {
      const timeout = setTimeout(() => setError(""), 5000);
      return () => clearTimeout(timeout);
    }
  }, [error]);

  const handleToggleChange = (e) => {
    const { name, checked } = e.target;
    setState(prevState => ({ ...prevState, [name]: checked }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState(prevState => ({ ...prevState, [name]: value }));
  };

  const handleDateChange = (date, name) => {
    setState(prevState => ({ ...prevState, [name]: date }));
  };

  const updateFormsBasedOnProfileSelect = (camperProfile) => {
    try {
      const [camperId] = camperProfile;
      onExistingCamperSelect(camperId);
      nextStep();
    } catch (err) {
      setError("There was an error selecting the profile. Please try again.");
    }
  };

  const saveAndContinue = (e) => {
    e.preventDefault();
    saveValues(state);
    nextStep();
  };

  // Handle keyboard navigation
  const handleKeyPress = (e, callback) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      callback(e);
    }
  };

  return (
    <form 
      className="new-step-form" 
      autoComplete="off"
      onSubmit={saveAndContinue}
      role="form"
      aria-label="Attendee Registration Form"
    >
      {/* Error announcer for screen readers */}
      {error && (
        <div 
          role="alert" 
          className="error-message" 
          aria-live="polite"
        >
          {error}
        </div>
      )}

      {existing_profiles?.length > 0 && (
        <section style={{ "padding": "1em" }} aria-labelledby="existing-profiles-header">
          <header className="header-section">
            <h1 id="existing-profiles-header" tabIndex="-1">
              My Attendee Profiles
            </h1>
            <p 
              className="subheader"
              id="profiles-description"
            >
              Select an existing attendee profile for Firewood Pay express registration.
            </p>
          </header>

          <div 
            className="row"
            role="region" 
            aria-labelledby="profiles-description"
          >
            <AttendeeProfileList
              onExistingAttendeeProfileSelect={updateFormsBasedOnProfileSelect}
              profilesJson={existing_profiles}
              // Pass additional props for accessibility
              aria-label="Existing attendee profiles"
              role="listbox"
            />
          </div>
        </section>
      )}

      <button
        type="submit"
        className="button button-primary create"
        style={buttonStyles}
        aria-label="Register new attendee"
        onKeyPress={(e) => handleKeyPress(e, saveAndContinue)}
      >
        Register New Attendee
      </button>
    </form>
  );
};

ExistingAttendeeForm.defaultProps = {
  existing_profiles: [],
  onExistingCamperSelect: () => {},
  saveValues: () => {},
  nextStep: () => {},
  buttonStyles: {}
};

export default ExistingAttendeeForm;